import {
	TakeCargoDatabase,
} from './models/database.model';

export const database = new TakeCargoDatabase();
export * from './enums/setting-key.enum';
export * from './enums/table-name.enum';
export * from './database.util';